import { render, staticRenderFns } from "./NoResponseBanner.vue?vue&type=template&id=508841fd"
import script from "./NoResponseBanner.vue?vue&type=script&lang=js"
export * from "./NoResponseBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports